import { makeStyles } from '@material-ui/styles';
 
const useStyles = makeStyles({
    textField: {
        width: '100%',
        maxWidth: '100%',
    },
})

export default useStyles;